/**
 * @file 页面数据
 */

export default [
    {
        id: 0,
        label: '框架简介',
        children: [
            {
                id: 1,
                label: '介绍',
                doc: 'introduction/introduction.md'
            },
            {
                id: 2,
                label: '技术方案全景',
                doc:'architecture/architecture.md'
            }
        ]
    },
    {
        id: 3,
        label: '快速开始',
        children: [
            {
                id: 4,
                label: '环境安装',
                doc: 'quick_start/install/README.md'
            },
            {
                id: 5,
                label: '模型部署',
                doc: 'quick_start/develop_procedure/test.md'
            },
            {
                id: 6,
                label: '预测流程',
                doc: 'quick_start/predict/README.md'
            },
            {
                id: 7,
                label: 'demo',
                doc: 'quick_start/demo/paddlejs.md'
            },
        ]
    }
];
